// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"333":"forum/components/SlideshowPage","593":"forum/components/CommunitySlideshow"}[chunkId] + ".js";
};